/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

// import moduleTodo from './todo/moduleTodo.js'
// import moduleCalendar from './calendar/moduleCalendar.js'
// import moduleChat from './chat/moduleChat.js'
// import moduleEmail from './email/moduleEmail.js'
import moduleAuth from './auth/moduleAuth.js'
import hijos from './modules/hijos.js'
import nodos from './modules/nodos.js'
import reservas from './modules/reservas.js'
import user from './modules/user.js'
import carrito from './modules/carrito.js'
import eCommerce from './eCommerce/moduleECommerce.js'


const dataPersisted = createPersistedState({
  paths: [
    "carrito",
    "hijos",
    "nodos",
    "reservas",
    "user",
  ],
});

export default new Vuex.Store({
    getters,
    mutations,
    state,
    actions,
    modules: {
        // todo: moduleTodo,
        // calendar: moduleCalendar,
        // chat: moduleChat,
        // email: moduleEmail,
        auth: moduleAuth,
        hijos,
        nodos,
        reservas,
        user,
        carrito,
        eCommerce
    },
    strict: process.env.NODE_ENV !== 'production',
    plugins: [dataPersisted],
})
